export default "__VITE_ASSET__CZy4Yt5X__"